<template>  
    <div class="service-area pt--70 pb--50 bg_color--1">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="text-center section-title mb--30">
              <h2 class="heading-title">Landlords &amp; Estate Agents</h2>
              <p class="description">
                We work with Landlords, developers and estate agents to provide
                solutions to their requirements.
              </p>
            </div>
          </v-col>
        </v-row>
        <v-row class="service-main-wrapper bg-white--service">
          <v-col
            lg="4"
            md="4"
            sm="6"
            cols="12"
            v-for="(listGroup, i) in listInfo"
            :key="i"
          >
            <div class="service service__style--2 text-left bg-gray">
              <div class="service">
                <div class="icon">
                  <div v-html="iconSvg(listGroup.icon)"></div>
                </div>
                <div class="content">
                  <h3 class="heading-title">{{ listGroup.title }}</h3>
                  <ul class="list-style--1">
                    <li
                      class="d-flex"
                      v-for="(item, j) in listGroup.list"
                      :key="j"
                    >
                      <i v-html="iconSvg(item.icon)"></i>
                      {{ item.desc }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>  
</template>
<script>
import feather from "feather-icons";
export default {
  data() {
    return {
      listInfo: [
        {
          icon: "home",
          title: "Landlords & Estate Agents",
          list: [
            {
              icon: "check",
              desc: `HMO Landlords - Are you tired of chasing rent payments?`,
            },
            {
              icon: "check",
              desc: `Struggling to fill your rooms?`,
            },
            {
              icon: "check",
              desc: `Tired of paying high gas bills in winter?`,
            },
            {
              icon: "check",
              desc: `Are you looking for a break from tenant management?`,
            },
            {
              icon: "check",
              desc: `We can help you solve your problems.`,
            },
            {
              icon: "check",
              desc: `The Property Lease Option or Management Option is for you.`,
            },
          ],
        },
        {
          icon: "layers",
          title: "Property Lease Option",
          list: [
            {
              icon: "check",
              desc: `Guaranteed Rent monthly`,
            },
            {
              icon: "check",
              desc: `This option helps you get your life back`,
            },
            {
              icon: "check",
              desc: `We do the hard work, while you play golf or go shopping`,
            },
            {
              icon: "check",
              desc: `Total peace of mind`,
            },
            {
              icon: "check",
              desc: `Guaranteed Rent monthly`,
            },
          ],
        },
        {
          icon: "users",
          title: "Management Option",
          list: [
            {
              icon: "check",
              desc: `We offer a professional service to manage your property, finding you the best tenants.`,
            },
            {
              icon: "check",
              desc: `We charge a management fee at % of gross income for this service.`,
            },
            {
              icon: "check",
              desc: `Your income is tied to the occupation of the property by our end user clients.`,
            },
            {
              icon: "check",
              desc: `Making sure your property is kept in good condition through regular cleaning, inspections and that rent payments are made on time.`,
            },
          ],
        },
      ],
    };
  },
  methods: {
    iconSvg(icon) {
      return feather.icons[icon].toSvg();
    },
  },
};
</script>
